<script>
import {
  CalcTypes,
  ConstructionTypes,
  InputType,
  Params,
  SizeParams,
  Structures
} from '@/utils/types'

export default {
  name: 'DropdownConfigsMixin',
  data: () => ({
    validityMap: {}
  }),
  methods: {
    getLabel() {
      const translateKeyMap = {
        [Structures.facing]: `facingParams.${Structures.facing}`,
        [Structures.facingInnerLayer]: `facingParams.${Structures.facing}`,
        [Structures.isolation]: `isolationParams.${Structures.isolation}`,
        [Structures.base]: `params.${Structures.base}`,
        [Structures.screed]: `params.${Structures.screed}`,
        [Structures.soundIsolation]: `soundIsolationParams.${Structures.soundIsolation}`
      }
      const translateKey = translateKeyMap[this.type]

      return this.$t(`message.constructionParams.${translateKey}`)
    },
    defineValidity(evt) {
      const { index, param, validity } = evt
      if (!this.validityMap[index]) {
        this.validityMap[index] = {}
      }
      this.validityMap[index][param] = validity
      const hasSectorInvalidParams = Object.values(this.validityMap[index]).some(value => !value)
      this.$store.commit('UPDATE_SECTOR', {
        index,
        property: 'isValid',
        subproperty: null,
        value: hasSectorInvalidParams ? false : validity })
    },
    getOptions(data, needOrder = false) {
      const options = data
        .map((item, index) => ({
          id: item.systemId ?? item.id ?? index,
          value: item.name ?? item.title ?? item,
          ...item
        }))

      return needOrder ? options.slice().sort((a, b) => a.order - b.order) : options
    },
    getValidationRule(param) {
      const key = `${param}Rule`

      if (this.material && this.material[key]) {
        const { min, max, unitType } = this.material[key]
        this.material.toolTip = `${min}-${max} ${unitType}`

        return { min, max }
      }
      return this.validationRules[this.currentConstructionType][CalcTypes.lite][param]
    }
  },
  computed: {
    dropdowns() {
      return [
        {
          id: 'buildingType',
          label: this.$t('message.constructionTypes.buildings.title'),
          source: this.buildingTypes,
          viewCondition: true,
          selected: this.buildingTypes[0],
          disabled: true,
          showDropdownCaretIcon: false
        },
        {
          id: 'location',
          label: this.$t('message.constructionTypes.location.title'),
          source: this.locations,
          viewCondition: true,
          selected: this.locations?.find((item) => item.id === this.location?.id)?.value ?? null,
          disabled: !this.buildingType,
          showDropdownCaretIcon: true
        }
      ]
    },
    validationRules() {
      return {
        [ConstructionTypes.floor]: {
          [CalcTypes.lite]: {
            density: { min: 1, max: 2800 },
            thickness: { min: 140, max: 1000 }
          }
        },
        [ConstructionTypes.wall]: {
          [CalcTypes.lite]: {
            density: { min: 1, max: 500 },
            thickness: { min: 50, max: 500 }
          }
        }
      }
    },
    structure() {
      return [
        {
          id: this.type,
          label: this.getLabel(),
          source: this.formattedMaterials,
          viewCondition: !this.isSizes,
          selected: this.title,
          disabled: this.isFacingInnerLayer ? this.sector.facingInnerLayer.facingInnerLayerBlocked : false,
          validationRules: null,
          type: InputType.integer,
          tooltip: null,
          showDropdownCaretIcon: true
        },
        {
          id: Params.density,
          label: this.$t('message.constructionParams.common.density'),
          source: this.densities,
          viewCondition: this.isFacing || this.isBase || this.isFacingInnerLayer,
          selected: this.selected?.density ?? null,
          editable: this.material?.isCustomDensity,
          disabled: !this.title,
          validationRules: this.getValidationRule('density'),
          type: InputType.integer,
          tooltip: this.material?.densityRule ? this.material?.toolTip : null,
          showDropdownCaretIcon: true
        },
        {
          id: Params.thickness,
          label: this.$t('message.constructionParams.common.thickness'),
          source: this.thicknesses,
          viewCondition: !this.isSizes,
          selected: this.selected?.thickness ?? null,
          editable: this.material?.isCustomThickness,
          disabled: !this.title,
          validationRules: this.getValidationRule(Params.thickness),
          type: InputType.integer,
          tooltip: this.material?.thicknessRule ? this.material?.toolTip : null,
          showDropdownCaretIcon: true
        },
        {
          id: Params.sheets,
          label: this.$t('message.constructionParams.common.sheets'),
          source: this.sheets,
          viewCondition: this.isFacing,
          selected: this.selected?.sheets ?? null,
          disabled: !this.title,
          validationRules: null,
          type: InputType.text,
          tooltip: null,
          showDropdownCaretIcon: true
        },
        {
          id: SizeParams.x,
          label: this.$t('message.constructionParams.common.length'),
          source: [],
          viewCondition: this.isSizes,
          selected: this.selected?.x ?? null,
          disabled: this.sector.sizes.sizesBlocked,
          validationRules: null,
          type: InputType.float,
          tooltip: null,
          editable: true,
          unit: this.$t('message.units.m'),
          showDropdownCaretIcon: false
        },
        {
          id: SizeParams.y,
          label: this.$t(`message.constructionParams.common.${this.isCeiling ? 'width' : 'height'}`),
          source: [],
          viewCondition: this.isSizes,
          selected: this.selected?.y ?? null,
          disabled: this.sector.sizes.sizesBlocked,
          validationRules: null,
          type: InputType.float,
          tooltip: null,
          editable: true,
          unit: this.$t('message.units.m'),
          showDropdownCaretIcon: false
        }
      ]
    }
  }
}
</script>
